export default __webpack_public_path__ + "static/media/reset-zoom-icon.51eadd28.svg";